export default __webpack_public_path__ + "src/images/home/Six Months Later-4005f8403b35763bdbc0a3baba9be28a.jpg";